import InboxMobile from '@/components/Inbox/InboxMobile';
import InboxWeb from '@/components/Inbox/InboxWeb';
import { useOutlet } from '@/context/OutletContext';

function Inbox() {
  const { env } = useOutlet();

  const InboxRender = env === 'web' ? InboxWeb : InboxMobile;

  return (
    <InboxRender />
  );
}

export default Inbox;
